import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { FAR_FILE_ALT } from '../../const/iconProps';
import { isMonthly, isPN4 } from '../../helpers';
import i18n from '../../strings/i18n';
import ClickHereLink from './ClickHereLink';
import Disclaimer from './Disclaimer';
const getLegalText = ({ type: productType }) => {
    if (isMonthly(productType)) {
        return 'monthlyImportantInformation';
    }
    return 'readImportantInformation';
};
const AutopayLegal = ({ heading, product, billing, featureFlags }) => {
    if (isPN4(product.type)) {
        return null;
    }
    const legalText = getLegalText(product);
    return (_jsx(Disclaimer, { dataCy: "autopay-terms-and-conditions", headingText: heading, iconFAText: FAR_FILE_ALT, paragraph: _jsx(Trans, { components: [
                _jsx(ClickHereLink, { billing: billing, featureFlags: featureFlags, product: product })
            ], i18n: i18n, i18nKey: `legal.${legalText}` }) }));
};
export default AutopayLegal;
